import { ApplyOnlineOptionsConst } from "@/src/constants/apply-online";
import CustomDate from "@/src/components/CustomUtils/CustomDate/CustomDate";
import ArrowSelect from "@/src/svg/applyOnline/ArrowSelectSvg";
import { IFormApplicationProps } from "@/src/types/applyOnline";
import { FC, useState } from "react";
import { Controller } from "react-hook-form";

const FormApplicationDopInfo: FC<IFormApplicationProps> = ({ register, control, errors, handleFocus }) => {
  const [isBirthDateOpen, setIsBirthDateOpen] = useState(false);

  const handleBirthDateFocus = () => {
    setIsBirthDateOpen(true);
    handleFocus?.("birthDate");
  };

  return (
    <div className="form-application-additional-info">
      <div className="form-application-header">
        <h1 className="form-application-header-title">Additional Information</h1>
      </div>
      <div className="form-application-body">
        <Controller
          name="birthDate"
          control={control}
          render={({ field }) => (
            <div className="form-application-body-field birthDate">
              <input
                className="form-application-body-input birthDate"
                type="text"
                placeholder="Date of Birth"
                value={field.value ?? ""}
                onFocus={handleBirthDateFocus}
                onClick={handleBirthDateFocus}
                readOnly
              />
              {isBirthDateOpen && (
                <CustomDate
                  value={field.value ?? ""}
                  onChange={(value) => field.onChange(value)}
                  onClose={() => setIsBirthDateOpen(false)}
                />
              )}
            </div>
          )}
        />
        <div className="form-application-body-select nationality">
          <select
            className="form-application-body-input select"
            defaultValue=""
            onFocus={() => handleFocus?.("nationality")}
            {...register("nationality")}
          >
            {ApplyOnlineOptionsConst.nationality.map(({ value, label, disabled }) => (
              <option key={value} value={value} disabled={disabled}>
                {label}
              </option>
            ))}
          </select>
          <ArrowSelect />
        </div>
        <div className="form-application-body-select country">
          <select
            className="form-application-body-input select"
            defaultValue=""
            onFocus={() => handleFocus?.("country")}
            {...register("country")}
          >
            {ApplyOnlineOptionsConst.country.map(({ value, label, disabled }) => (
              <option key={value} value={value} disabled={disabled}>
                {label}
              </option>
            ))}
          </select>
          <ArrowSelect />
        </div>
        <div className="form-application-body-field address">
          <div className="form-application-body-field-label">
            <label htmlFor="apply-online-address">Address</label>
            <div className="form-application-body-field-label-line"></div>
          </div>
          <input
            id="apply-online-address"
            className="form-application-body-input address"
            type="text"
            onFocus={() => handleFocus?.("address")}
            {...register("address")}
          />
        </div>
      </div>
    </div>
  );
};

export default FormApplicationDopInfo;
